import React from 'react';
import { Dialog } from './../../common/dialog';

const MessageModal = (props) => {
    const hideHandler = () => {
        props.hideMessageModal();
    };

    let name = null;
    if (parseInt(props.signUpType) === 5) {
        name = 'UT Physicians';
    } else if (parseInt(props.signUpType) === 6) {
        name = 'UTHealth Houston';
    }

    let actions = [
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Accept</button>
    ];
    return (
        <Dialog
            name="personal-login-message-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 800 }}
            bodyStyle={{ overflow: 'initial' }}
            className="personal-login-message-dialog"
        >
            <div className="personal-login-message-modal-container">
                <h1>Creating {name} Account</h1>
                <p className="notice">
                    You are about to create an account for the {name} platform.
                </p>
            </div>
        </Dialog>
    );
};

export default MessageModal;
